// extracted by mini-css-extract-plugin
module.exports = {"menu":"Burger_menu__J2CXv","line":"Burger_line__wTeck","line1":"Burger_line1__zSVB0","line2":"Burger_line2__1EWLh","line3":"Burger_line3__gazCd","opened":"Burger_opened__PzzHE"};